import { render } from "./PublicationUpdate.vue?vue&type=template&id=4a45e8b1"
import script from "./PublicationUpdate.vue?vue&type=script&lang=js"
export * from "./PublicationUpdate.vue?vue&type=script&lang=js"
script.render = render

export default script